/* Core & libraries */
import React, {useEffect, useState} from "react";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch } from "../endpoints/base";
import { AS_ADMIN_LOGIN_URLS } from "../endpoints/endpoints";

export const useAsAdminService = () => {
  const { genericApiFetch } = useGenericApiFetch();

  const getAdminLoginUrls = async () => {
    const response = await genericApiFetch({
      url: AS_ADMIN_LOGIN_URLS,
      method: "GET"
    });

    if (response.success) {
      return response.data;
    }

    return null;
  };

  return {
    getAdminLoginUrls,
  };
};